import { Show } from 'solid-js';
import { PayPaymentMethodsProvider } from '~/contexts/pay';
import { PortalPaymentAccountsProvider } from '~/contexts/portal-payment-accounts';
import { mode, PaymentMode } from '~/hooks/usePaymentMode';
import type { Component, JSX } from 'solid-js';

/** Mounts only one of Portal or Pay payment provider based on paymentMode. */
export const PaymentProviderBranch: Component<{ children: JSX.Element }> = (props) => {
  return (
    <Show when={mode() === PaymentMode.Portal} fallback={PayPaymentMethodsProvider(props)}>
      {PortalPaymentAccountsProvider(props)}
    </Show>
  );
};
